export enum AdType {
    RON_Flex_Sky = 'RON_Flex_Sky',
    RON_Flex_300w = 'RON_Flex_300w',
    RON_Flex_Leader = 'RON_Flex_Leader',
    RON_Footerboard = 'RON_Footerboard',
    RON_Interstitial = 'RON_Interstitial',
    RON_Reveal = 'RON_Reveal'
  }
  